import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionWithRadioTrigger,
} from "@/components/ui/accordion";
import { SquareArrowOutUpRight } from "lucide-react";
import { useEstimateInfo } from "../hooks/useScenarioStore";
import { useParams } from "react-router-dom";
import { useReadProjectGroupsItemSheet } from "@/libs/react-query/hooks/useItemsheetsQuery";
import ScenarioEstimateTable from "./ScenarioEstimateTable";

type Props = {
  selectedAccordionValue: string;
  setSelectedAccordionValue: (value: string) => void;
};

export default function ScenarioEstimateAccordion({
  selectedAccordionValue,
  setSelectedAccordionValue,
}: Props) {
  const { group_id = "" } = useParams();

  const estimateInfo = useEstimateInfo();

  const { data } = useReadProjectGroupsItemSheet(group_id, {
    project_id: estimateInfo.projectId,
    project_type: estimateInfo.projectType,
    original_id: estimateInfo.originalId,
  });

  const handleChange = (value: string) => {
    setSelectedAccordionValue?.(value);
  };

  const handleRedirectEstimate = (
    e: React.MouseEvent<SVGElement>,
    latestSheetId: string
  ) => {
    e.stopPropagation();

    window.open(
      `/management/projects/${group_id}/estimates/${estimateInfo.projectId}/original/${estimateInfo.originalId}/itemsheet/${latestSheetId}`,
      "_blank"
    );
  };

  if (!data?.latests?.length) {
    return (
      <div className="w-full h-24 flex items-center justify-center">
        <p className="text-2xl text-gray-B font-semibold">
          산출내역서가 없습니다
        </p>
      </div>
    );
  }

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full p-5 flex flex-col gap-5"
      onValueChange={handleChange}
      defaultValue={selectedAccordionValue ?? undefined}
    >
      {data.latests.map((item, index) => (
        <AccordionItem
          value={item.id}
          key={`${item.id}-${index}`}
          className="border-none"
        >
          <AccordionWithRadioTrigger className="py-0 flex gap-2 items-center hover:no-underline">
            <div className="flex gap-4 items-center">
              <span className="text-sm text-dark-red font-bold">
                {item.title}
              </span>
              <div>
                <SquareArrowOutUpRight
                  className="text-gray-B"
                  size={16}
                  onClick={(e) => handleRedirectEstimate(e, item.id)}
                />
              </div>
            </div>
          </AccordionWithRadioTrigger>
          <AccordionContent className="text-gray-B text-xs font-normal mt-2  w-full max-h-96 overflow-auto">
            {selectedAccordionValue && (
              <ScenarioEstimateTable itemSheetId={selectedAccordionValue} />
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
